export default "__VITE_ASSET__CIKNwlZZ__"